import { render, staticRenderFns } from "./terminalManual.vue?vue&type=template&id=510a3876&"
import script from "./terminalManual.vue?vue&type=script&lang=js&"
export * from "./terminalManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports